// src/components/CreatePoll.js
import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { db, auth } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { AuthContext } from '../context/AuthProvider'; // Assuming you have an AuthContext to provide the current user

export default function CreatePoll() {
  const [optionCount, setOptionCount] = useState(2); // Set initial poll options count to 2 (min options)
  const [options, setOptions] = useState(["", ""]); // Start with two empty options
  const [pollQuestion, setPollQuestion] = useState(""); // State for the poll question

  // Access the user from AuthContext (assuming you have a context to track logged-in user)
  const { user } = useContext(AuthContext); // User is the current logged-in user

  // Handle changing the number of options
  const handleIncrease = () => {
    if (optionCount < 4) {
      setOptionCount(prevCount => prevCount + 1);
      setOptions(prevOptions => [...prevOptions, ""]); // Add a new empty option
    }
  };

  const handleDecrease = () => {
    if (optionCount > 2) {
      setOptionCount(prevCount => prevCount - 1);
      setOptions(prevOptions => prevOptions.slice(0, -1)); // Remove the last option
    }
  };

  // Handle option change in each input
  const handleOptionChange = (index, event) => {
    const newOptions = [...options];
    newOptions[index] = event.target.value;
    setOptions(newOptions);
  };

  // Handle poll question change
  const handlePollQuestionChange = (event) => {
    setPollQuestion(event.target.value);
  };

  // Handle poll submission to Firebase
  const handleCreatePoll = async (e) => {
    e.preventDefault();

    if (!pollQuestion.trim()) {
      alert("Please enter a poll question.");
      return;
    }

    // Ensure that options have values
    const validOptions = options.filter(option => option.trim());

    if (validOptions.length < 2) {
      alert("Please enter at least 2 options.");
      return;
    }

    try {
      // Save the poll to Firestore
      await addDoc(collection(db, "polls"), {
        question: pollQuestion,
        options: validOptions,
        userId: user.uid,  // Store the UID of the user who created the poll
        timestamp: serverTimestamp(),
      });

      alert("Poll created successfully!");
      // Clear the form after successful submission
      setPollQuestion("");
      setOptions(["", ""]);
    } catch (error) {
      console.error("Error creating poll: ", error);
      alert("Failed to create poll. Please try again.");
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center pt-5">
        <div className="col-10 card">
          <div className="card-body">
            <h4 className='text-center'>Create Poll</h4>
            <form onSubmit={handleCreatePoll}>
              {/* Poll question input */}
              <div className="mb-3">
                <label htmlFor="pollQuestion" className="form-label">Poll Question</label>
                <input
                  type="text"
                  className="form-control"
                  id="pollQuestion"
                  placeholder="Enter your poll question here"
                  value={pollQuestion}
                  onChange={handlePollQuestionChange}
                />
              </div>

              {/* Poll options */}
              {options.map((option, index) => (
                <div key={index} className="mb-3">
                  <label htmlFor={`option${index}`} className="form-label">Option {index + 1}</label>
                  <input
                    type="text"
                    className="form-control"
                    id={`option${index}`}
                    value={option}
                    onChange={(e) => handleOptionChange(index, e)}
                    placeholder={`Option ${index + 1}`}
                  />
                </div>
              ))}

              {/* Option control buttons */}
              <div className="d-flex justify-content-between mt-3">
                <button type="button" className="btn btn-outline-secondary" onClick={handleDecrease} disabled={optionCount <= 2}>-</button>
                <button type="button" className="btn btn-outline-secondary" onClick={handleIncrease} disabled={optionCount >= 4}>+</button>
              </div>

              {/* Create poll button */}
              <div className="post d-flex justify-content-center mt-4 mb-3">
                <input type="submit" value="Create Poll" className='btn btn-secondary w-75' />
              </div>
            </form>

            {/* Link to switch between CreatePoll and CreateQuote */}
            <div className="other text-center mt-3">
              <Link to='/create/CreateQoute' className='text-black text-decoration-underline'>
                Create Quote?
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
